export default function access() {
    const localPermissions: string | null = localStorage.getItem('permissions');

    if (!localPermissions) return;

    let permissions: string[] = JSON.parse(localPermissions);

    const claimsObjects = {};

    permissions.forEach((permission: string) => {
        claimsObjects[permission] = true;
    });

    return claimsObjects;
}
